import useExportRunsheetDialogViewModel from './ExportRunsheetDialogViewModel'
import cn from 'clsx'

import CustomModal, { ModalBody, ModalFooter, ModalHeader } from '@/components/shared/CustomModal'
import ExportRunsheetDialogErrorView from './views/ExportRunsheetDialogErrorView'
import ExportRunsheetDialogExportingView from './views/ExportRunsheetDialogExportingView'
import ExportRunsheetDialogReadyView from './views/ExportRunsheetDialogReadyView'

const ExportRunsheetDialog = ({
    className,
    documents,
}) => {
    
    const vm = useExportRunsheetDialogViewModel(documents)
    
    return (
        
        <CustomModal
            className={cn('ExportRunsheetDialog', className)}
            open={vm.open}
            modalHandler={() => vm.setOpen(false)}
            center>
            
            <ModalHeader>
                Export Runsheet: {vm.runsheet?.name}
                <div className="text-sm text-base-content/60">{vm.currentTab.name}</div>
            </ModalHeader>
            
            <ModalBody>
                
                {vm.error && (
                    <ExportRunsheetDialogErrorView
                        error={vm.error}
                        onTryAgainClick={() => vm.setError(null)} />
                )}
                
                {!vm.error && vm.isDownloading && (
                    <ExportRunsheetDialogExportingView
                        progressMax={vm.downloadProgressMax}
                        progressValue={vm.downloadProgressValue} />
                )}
                
                {!vm.error && !vm.isDownloading && (
                    <ExportRunsheetDialogReadyView
                        templates={vm.templates}
                        sheet={vm.sheet}
                        activeTab={vm.activeTab}
                        selectedTypes={vm.selectedTypes}
                        selectedTemplate={vm.selectedTemplate}
                        tabToExport={vm.tabToExport}
                        onExportTypeChange={vm.onExportTypeChange}
                        onTabToExportChange={vm.onTabToExportChange}
                        onTemplateChange={vm.onTemplateChange}
                        onSheetChange={vm.onSheetChange} />
                )}
            
            </ModalBody>
            
            {!vm.error && (
                <ModalFooter>
                    <button
                        className="mr-3 btn btn-primary btn-outline"
                        onClick={vm.closeDialog}>
                        Cancel
                    </button>
                    <button
                        className="btn btn-primary"
                        disabled={vm.error || !vm.selectedTypes.length || !vm.selectedTemplate || !documents?.length 
                            || vm.isDownloading}
                        onClick={vm.onExportRunsheetClick}>
                        Export
                    </button>
                </ModalFooter>
            )}
        
        </CustomModal>
        
    )
    
}

export default ExportRunsheetDialog
